import { useCallback, useEffect, useState } from "react";
import { useMutation } from "urql";
import { graphql } from "../../__generated__/gql";
import DetailsForm from "./DetailsForm";

const UpdateBrandDescriptionMutation = graphql(/* GraphQL */ `
  mutation updateBrandDescription($description: String!) {
    updateBrandSettings(input: { companyDescription: $description }) {
      companyDescription
    }
  }
`);

function Description({
  setMessage,
  onBack,
  onNext,
  companyDescription,
}: {
  setMessage: (message: string) => void;
  onBack: () => void;
  onNext: () => void;
  companyDescription?: string | null;
}) {
  const [ready, setReady] = useState(!!companyDescription);

  const [, updateBrandDescription] = useMutation(
    UpdateBrandDescriptionMutation,
  );

  const onSubmit = useCallback(
    async (data: { value: string }) => {
      await updateBrandDescription({ description: data.value });
      onNext();
    },
    [onNext, updateBrandDescription],
  );

  useEffect(() => {
    if (!ready) {
      setMessage("Give me a moment to learn about your brand");

      setTimeout(() => {
        setReady(true);
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (ready && companyDescription) {
      setMessage("How does this look? Feel free to make any changes.");
    }
  }, [companyDescription, ready, setMessage]);

  return (
    <DetailsForm
      label="About"
      onSubmit={onSubmit}
      onBack={onBack}
      value={ready ? companyDescription : null}
    />
  );
}

export default Description;
